import type { IconSvgObject } from './types';

const AlignVerticalSpaceAroundIcon: IconSvgObject = [
  ["path", { d: "M14 9.5L10 9.5C8.89543 9.5 8 10.3954 8 11.5L8 12.5C8 13.6046 8.89543 14.5 10 14.5L14 14.5C15.1046 14.5 16 13.6046 16 12.5V11.5C16 10.3954 15.1046 9.5 14 9.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 18.5L3 18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 5.5L3 5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AlignVerticalSpaceAroundIcon;
